var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneguest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 25,
    viewBox: "0 0 19 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.22643 5.34011C4.22643 2.48715 6.53903 0.174561 9.39198 0.174561C12.2449 0.174561 14.5575 2.48715 14.5575 5.34011C14.5575 8.19301 12.2449 10.5057 9.39198 10.5057C6.53903 10.5057 4.22643 8.19306 4.22643 5.34011ZM11.5838 10.8579H7.20043C3.55368 10.8579 0.58667 13.8248 0.58667 17.4711V22.8331L0.600403 22.9167L0.970501 23.0322C4.45012 24.1192 7.47422 24.482 9.9629 24.482C14.8237 24.482 17.6407 23.0959 17.8152 23.0078L18.1608 22.8324L18.1972 22.8327V17.4711C18.1972 13.8248 15.2303 10.8579 11.5838 10.8579Z",
    fill: "#888888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneguest);
export default __webpack_public_path__ + "static/media/oneguest.84377d706ffa07d6469a00d240dd8ae4.svg";
export { ForwardRef as ReactComponent };